/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type useNextPaymentDateFragment = {
    readonly boughtOn: string | null;
    readonly property: {
        readonly ownerPaymentDayOfMonth: number;
    };
    readonly " $refType": "useNextPaymentDateFragment";
};
export type useNextPaymentDateFragment$data = useNextPaymentDateFragment;
export type useNextPaymentDateFragment$key = {
    readonly " $data"?: useNextPaymentDateFragment$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"useNextPaymentDateFragment">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useNextPaymentDateFragment",
  "selections": [
    {
      "alias": "boughtOn",
      "args": null,
      "kind": "ScalarField",
      "name": "bought_on",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "properties",
      "kind": "LinkedField",
      "name": "property",
      "plural": false,
      "selections": [
        {
          "alias": "ownerPaymentDayOfMonth",
          "args": null,
          "kind": "ScalarField",
          "name": "owner_payments_day_of_month",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "property_fractions",
  "abstractKey": null
};
(node as any).hash = '25db57ee1ad744cfe2aeded80edd1b73';
export default node;
